import { createStyles, withStyles, type WithStyles } from "@material-ui/core";
import { CustomTable } from "features/shared/components";
import React from "react";
import arrayUtils from "shared/arrayUtils";
import type { Corral, LivestockInfo, Retreat } from "shared/types";
import type { CorralFilterFormState } from "../corral.types";
import { useCorralListTable } from "../hooks/useCorralListTable";
import { filterCorralPredicate } from "../utils/corral.utils";

type CorralListTableProps = {
  corrals: Corral[];
  filterForm: CorralFilterFormState;
  isFormPanelOpen: boolean;
  livestockInfos: LivestockInfo[];
  onDeleteRequest: (row: Corral) => void;
  onEditClick: (row: Corral) => void;
  retreats: Retreat[];
} & WithStyles<typeof styles>;

function CorralListTable({
  corrals,
  filterForm,
  isFormPanelOpen,
  livestockInfos,
  onDeleteRequest,
  onEditClick,
  retreats,
}: CorralListTableProps) {
  const { columns } = useCorralListTable({
    isFormPanelOpen,
    livestockInfos,
    onDeleteRequest,
    onEditClick,
    retreats,
  });

  const filteredRows = arrayUtils.filterItems({
    items: corrals,
    predicate: (item) => filterCorralPredicate(item, filterForm),
  });

  return (
    <CustomTable
      columns={columns}
      getRowId={(row) => row.id.toString()}
      id="corral-list-table"
      rows={filteredRows}
    />
  );
}

const styles = () => createStyles({});

export default withStyles(styles)(CorralListTable);
